import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SaveCardForm from '../components/userDashboard/SaveCardForm'; // Adjust path if needed
import toast from 'react-hot-toast';

const AddPaymentMethodPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // This allows us to redirect the user back to where they came from (the premium page)
    const from = location.state?.from || '/';

    const handleSaveSuccess = () => {
        toast.success("Payment method saved!");
        // Navigate back to the page that sent the user here
        navigate(from);
    };

    return (
        <div className="p-4 max-w-md mx-auto min-h-screen transition-colors">
            <div className="p-6 border border-slate-200 dark:border-brand-gray/50 rounded-2xl bg-white dark:bg-brand-black shadow-sm transition-colors">
                <SaveCardForm onSaveSuccess={handleSaveSuccess} />
            </div>

            <p className="text-center text-xs text-gray-500 dark:text-brand-gray mt-6 px-4">
                You can update or remove your card details at any time in your user dashboard.
            </p>
        </div>

        
    );
};

export default AddPaymentMethodPage;